import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { Panel } from "primereact/panel";

import { useCreateSecretaria1Mutation, useCreateSecretariaMutation } from "./SecretariaApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { ISsecretaria, Secretaria } from "../../types/secretaria/Secretaria";
import { SecretariaForm } from "./SecretariaForm";
import { Orgao } from "../../types/orgao/Orgao";
import { useSecretariaRoutes } from "../../config/useSecretariaRoutes";



export const SecretariaCreate = () => {

    const [secretaria, setSecretaria] = useState<Secretaria>(ISsecretaria);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createSecretaria, status] = useCreateSecretaria1Mutation();
    const navigate = useNavigate();
    const secretariaRoutes=useSecretariaRoutes();


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setSecretaria((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handleCepChange = (newCep: string) => {
        // Aqui você pode atualizar o estado com o novo valor de CEP
        setSecretaria((prev) => ({
            ...prev,
            cep: newCep,
        }));
    };

    const handleSearchOrgaoChange = (parOrgao: Orgao | null) => {
        setSecretaria((prev) => ({
            ...prev,
            orgao: parOrgao ? {
                ...prev.orgao,
                id: parOrgao.id || "",  
                nome: parOrgao.nome || "",  
                
            } : null // Se parOrgao for null, deixa o orgao como null
        }));
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createSecretaria(secretaria);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(secretariaRoutes.SECRETARIA_LIST);
            // setSecretaria(ISsecretaria);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Secretaria de Governo
                </Typography>



                <SecretariaForm
                    data={secretaria}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleCepChange={handleCepChange}
                    handleSearchOrgaoChange={handleSearchOrgaoChange}
                />

            </Paper>










        </>







    );










};

/*
 <SecretariaTurmaForm
                    secretariaTurma={secretariaTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/